export default __webpack_public_path__ + "static/media/schedule.008db48c.svg";